import { get } from 'lodash'

import { Media } from "@skinsoft/types";

export const id = (media: Media) => get(media, 'id')
export const fileName = (media: Media) => {
    return get(media, "fileRecordCS.fileName.value")
}